module.exports = "images/high_performance_laptops@2x.png";